import React, { Fragment } from 'react'

// Modal component with overlay and slide-in panel

const Modal = ({ isOpen, onClose, title, children, loading }) => {
    if (!isOpen) return null;

    return (
        <Fragment>
            <div className="fixed inset-0 bg-black/50 z-30" onClick={onClose}></div>
            <div className="fixed right-0 top-0 h-screen w-full max-w-4xl bg-white dark:bg-gray-800 shadow-lg z-40 overflow-y-auto">
                <div className="p-6">
                    <div className="flex items-center justify-between mb-6">
                        <h2 className="text-xl font-semibold">{title}</h2>
                        <button
                            onClick={onClose}
                            disabled={loading}
                            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition"
                        >
                            <span className="material-icons sm">close</span>
                        </button>
                    </div>
                    {children}
                </div>
            </div>
        </Fragment>
    );
};

export default Modal
